.checkmark-icon {
  height: 20px;
  width: 20px;
  color: var(--green-05b45e);
}

.dash-icon {
  height: 20px;
  width: 20px;
  color: var(--gray-637381);
}
